import {
  setToken,
  setIdUser,
  getMainPath,
  setPermission,
  showInfoDialog
} from '@/api'
// mutations
const FORMLOGIN = (state, auth) => {
  state.auth = auth
}

const LOGIN = (state, auth) => {
  state.auth = auth
  if (auth.code === 1) {
    setToken(auth.data.token)
    setIdUser(auth.data.token)
    setPermission(auth.data.permission)
    state.token = auth.data.token
    state.status = 'success'
    window.location.href = getMainPath() + '#/dashboard'
    // next('/dashboard')
    // this.$router.push('/dashboard')
  } else {
    showInfoDialog('Mensaje Informativo',auth.message,'Aceptar')
    state.status = 'error'
  }
}

const LOGOUT = (state, auth) => {
  state.auth = auth
  localStorage.removeItem('tokenAdmin')
  window.location.reload()
}

export default {
  FORMLOGIN,
  LOGIN,
  LOGOUT
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js